// Mock data for the Ovamx app shell preview.
// Will be replaced by real /api endpoints in next iteration.

// Local avatar generator — inline SVG data URI (no external CDN, avoids ORB blocking).
const PALETTES = [
  ["#E07A5F", "#F5C9BC"],
  ["#121212", "#4A4A4A"],
  ["#0052FF", "#A8C0FF"],
  ["#C96A51", "#F7D9CC"],
  ["#1F2937", "#6B7280"],
  ["#9C5A3C", "#E8B79A"],
];

const initials = (name) =>
  name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

const av = (seed) => {
  const code = [...seed].reduce((a, c) => a + c.charCodeAt(0), 0);
  const [bg, fg] = PALETTES[code % PALETTES.length];
  const text = initials(seed);
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='${bg}'/><stop offset='1' stop-color='${fg}'/></linearGradient></defs><rect width='100' height='100' fill='url(%23g)'/><text x='50' y='58' text-anchor='middle' font-family='Outfit, system-ui, sans-serif' font-weight='600' font-size='40' fill='%23F7F5F0'>${text}</text></svg>`;
  return `data:image/svg+xml;utf8,${svg.replace(/#/g, "%23")}`;
};

export const currentUser = {
  id: "u-me",
  name: "Tú",
  handle: "@tu",
  avatar: av("Tu"),
  verified: true,
};

export const stories = [
  { id: "me",  name: "Tu historia", avatar: av("Tu"), me: true },
  { id: "s1",  name: "Lucía",   avatar: av("Lucia Romero"),   ring: "vinculos" },
  { id: "s2",  name: "Diego",   avatar: av("Diego Albamonte"), ring: "horizonte" },
  { id: "s3",  name: "Mei",     avatar: av("Mei Tanaka"),      ring: "vinculos" },
  { id: "s4",  name: "Kofi",    avatar: av("Kofi Mensah"),     ring: "horizonte" },
  { id: "s5",  name: "Sara",    avatar: av("Sara Iqbal"),      ring: "vinculos" },
  { id: "s6",  name: "Marco",   avatar: av("Marco Velez"),     ring: "horizonte" },
  { id: "s7",  name: "Aisha",   avatar: av("Aisha Karim"),     ring: "vinculos" },
  { id: "s8",  name: "Tomás",   avatar: av("Tomas Errea"),     ring: "horizonte" },
  { id: "s9",  name: "Yuki",    avatar: av("Yuki Sato"),       ring: "vinculos" },
  { id: "s10", name: "Ana",     avatar: av("Ana Castro"),      ring: "horizonte" },
];

export const posts = {
  vinculos: [
    {
      id: "p1",
      author: { name: "Lucía Romero", handle: "@luci", avatar: av("Lucia Romero"), verified: true, badge: "Cercano" },
      time: "hace 12 min",
      text: "Inauguramos el huerto familiar 🌱 — el pequeño está más feliz que nunca. Gracias a quienes vinieron a ayudar este finde.",
      image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1400&q=80",
      stats: { likes: 42, comments: 8, shares: 1 },
      audience: "Familia",
    },
    {
      id: "p2",
      author: { name: "Diego Albamonte", handle: "@diego", avatar: av("Diego Albamonte"), verified: false, badge: "Amigo" },
      time: "hace 1 h",
      text: "Pregunta seria: ¿alguien probó esa cafetería nueva en la calle Lavalle? Estoy juntando coraje para el espresso doble ☕",
      image: null,
      stats: { likes: 18, comments: 14, shares: 0 },
      audience: "Amigos",
    },
    {
      id: "p3",
      author: { name: "Mei Tanaka", handle: "@mei", avatar: av("Mei Tanaka"), verified: true, badge: "Cercano" },
      time: "hace 3 h",
      text: "Pequeño recuerdo del cumple de mamá. La torta no salió perfecta pero las risas sí.",
      image: "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?auto=format&fit=crop&w=1400&q=80",
      stats: { likes: 64, comments: 12, shares: 2 },
      audience: "Familia",
    },
    {
      id: "p4",
      author: { name: "Sara Iqbal", handle: "@sara", avatar: av("Sara Iqbal"), verified: false, badge: "Amiga" },
      time: "hace 5 h",
      text: "Recordatorio: el sábado nos juntamos en casa de Marco para ver la final. Llevo papas, alguien que se anote con bebidas 🙏",
      image: null,
      stats: { likes: 11, comments: 22, shares: 0 },
      audience: "Amigos",
    },
  ],
  horizonte: [
    {
      id: "h1",
      author: { name: "Kofi Mensah", handle: "@kofi.travels", avatar: av("Kofi Mensah"), verified: true, badge: "Creador" },
      time: "hace 8 min",
      text: "Acra al amanecer. La IA cultural me explicó por qué los pescadores cantan al subir la red — 200 años de tradición Ga.",
      image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=1400&q=80",
      stats: { likes: 1287, comments: 142, shares: 89 },
      audience: "Horizonte",
      reason: "Te interesa: Viajes culturales, África",
    },
    {
      id: "h2",
      author: { name: "Marco Vélez", handle: "@marco.builds", avatar: av("Marco Velez"), verified: true, badge: "Creador" },
      time: "hace 22 min",
      text: "Cómo lancé mi marca de muebles desde un garaje y vendí $84k en 6 meses con Ovamx Marketplace 🪑 Hilo abajo 👇",
      image: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?auto=format&fit=crop&w=1400&q=80",
      stats: { likes: 3421, comments: 287, shares: 412 },
      audience: "Horizonte",
      reason: "Te interesa: Emprendimiento, Diseño",
      signature: true,
    },
    {
      id: "h3",
      author: { name: "Aisha Karim", handle: "@aisha.codes", avatar: av("Aisha Karim"), verified: true, badge: "Pro" },
      time: "hace 1 h",
      text: "Mi taller de Python para principiantes empieza el lunes. Cupos limitados, $0 para los primeros 50. Link en perfil.",
      image: null,
      stats: { likes: 612, comments: 78, shares: 134 },
      audience: "Horizonte",
      reason: "Te interesa: Educación, Programación",
    },
    {
      id: "h4",
      author: { name: "Yuki Sato", handle: "@yuki.eats", avatar: av("Yuki Sato"), verified: false, badge: "Creador" },
      time: "hace 2 h",
      text: "Receta de ramen de mi abuela en Sapporo. Le pedí a la IA que lo tradujera al español manteniendo el tono. Quedó hermoso 🍜",
      image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?auto=format&fit=crop&w=1400&q=80",
      stats: { likes: 8910, comments: 521, shares: 1124 },
      audience: "Horizonte",
      reason: "Trending en gastronomía",
    },
  ],
};

export const onlineFriends = [
  { id: "f1", name: "Lucía Romero", avatar: av("Lucia Romero"), online: true },
  { id: "f2", name: "Diego Albamonte", avatar: av("Diego Albamonte"), online: true },
  { id: "f3", name: "Mei Tanaka", avatar: av("Mei Tanaka"), online: true },
  { id: "f4", name: "Sara Iqbal", avatar: av("Sara Iqbal"), online: false },
  { id: "f5", name: "Tomás Errea", avatar: av("Tomas Errea"), online: true },
  { id: "f6", name: "Ana Castro", avatar: av("Ana Castro"), online: false },
];

export const suggestedCommunities = [
  { id: "c1", name: "Padres del 2026", members: "248k", tag: "Familia" },
  { id: "c2", name: "Diseño y arte LATAM", members: "1.2M", tag: "Creativo" },
  { id: "c3", name: "Viajeros con IA", members: "420k", tag: "Viajes" },
  { id: "c4", name: "Emprendedores Pro", members: "890k", tag: "Negocio" },
];

export const trendingTopics = [
  { id: "t1", title: "IA cultural en viajes", count: "+12.4k posts" },
  { id: "t2", title: "Modo Horizonte explicable", count: "+9.1k posts" },
  { id: "t3", title: "Marketplace 0% comisión", count: "+6.7k posts" },
  { id: "t4", title: "Verificación gratuita", count: "+4.2k posts" },
];
